import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useT } from "@/lib/i18n";
import { ATLAS } from "@/constants/testIds";
import { Search } from "lucide-react";

export default function Cepages() {
  const { t } = useT();
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");

  useEffect(() => {
    api.get("/cepages")
      .then((r) => setItems(Array.isArray(r.data) ? r.data : []))
      .catch(() => setItems([]));
  }, []);

  const filtered = (Array.isArray(items) ? items : []).filter((c) =>
    [c.name, c.origin, ...(c.regions || [])].join(" ").toLowerCase().includes(q.toLowerCase())
  );

  return (
    <div className="max-w-6xl mx-auto px-5 md:px-10 py-12 md:py-16">
      <span className="chip-pink">{t("cepages.kicker")}</span>
      <h1 className="font-display text-4xl md:text-5xl tracking-tight text-[#1F3A5F] mt-4 font-medium">{t("cepages.title")}</h1>
      <p className="text-[#4A5568] mt-3 max-w-2xl">{t("cepages.subtitle")}</p>

      <div className="mt-8 max-w-md flex items-center gap-2 bg-white border border-[#1F3A5F]/15 focus-within:border-[#E5276A] rounded-xl px-4 py-3 shadow-sm">
        <Search className="w-4 h-4 text-[#8B95A1]" />
        <input data-testid={ATLAS.search} value={q} onChange={(e) => setQ(e.target.value)} placeholder={t("cepages.search")}
          className="flex-1 bg-transparent outline-none text-sm text-[#1F3A5F] placeholder:text-[#8B95A1]" />
      </div>

      <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {filtered.map((c) => {
          const isRed = (c.color || "").toLowerCase().includes("rouge") || (c.color || "").toLowerCase().includes("red");
          const isWhite = (c.color || "").toLowerCase().includes("blanc") || (c.color || "").toLowerCase().includes("white");
          const tint = isRed ? "from-[#7B1D3A]/20 via-[#FCE4ED]/40 to-[#FBF7F3]"
                     : isWhite ? "from-[#F5E5C8]/40 via-[#FBF7F3] to-white"
                     : "from-[#FBF7F3] via-[#FCE4ED]/40 to-[#FBF7F3]";
          return (
            <Link key={c.slug} to={`/cepages/${c.slug}`} data-testid={ATLAS.card(c.slug)} className="app-card overflow-hidden group">
              <div className={`aspect-[5/3] relative bg-gradient-to-br ${tint} flex items-center justify-center overflow-hidden`}>
                <div className="font-display text-6xl md:text-7xl text-[#1F3A5F]/15 group-hover:text-[#E5276A]/30 transition-colors duration-500 tracking-tighter">
                  {c.name?.[0] || "C"}
                </div>
                <div className="absolute bottom-2 right-3 text-[10px] uppercase tracking-widest text-[#1F3A5F]/45 font-bold">{c.origin}</div>
              </div>
              <div className="p-5">
                <div className="text-[10px] uppercase tracking-[0.18em] text-[#E5276A] font-semibold">{c.color}</div>
                <div className="font-display text-xl text-[#1F3A5F] font-medium mt-1.5">{c.name}</div>
                <div className="text-sm text-[#8B95A1] mt-0.5">{c.origin}</div>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
